<!-- https://www.figma.com/file/8qj3Smwuf9dQ4AIunIWX0f/Fondation-Beyeler-Kopie?node-id=548%3A5239 -->
<script>
    import GeneralVisitPage from "./GeneralVisitPage.svelte";
    import OpeningHours from "../common/info/OpeningHours.svelte";
    import DefaultButton from "../components/DefaultButton.svelte";
    import { restaurantObjects } from "../content/static/restaurants";
    import { _ } from "svelte-i18n";
    import { getLocale } from "../util/locale";
    import ContentSection from "../common/ContentSection.svelte";
    import Contact from "../common/info/Contact.svelte";

    let restaurant = restaurantObjects[getLocale()];
</script>

<main>
    <GeneralVisitPage
        title={restaurant.name}
        titleImage={restaurant.titleImage}
        shortDescription={restaurant.shortDescription}
        description={restaurant.description}
    >
        <div slot="subDescriptionArea" class="info-wrapper">
            <!-- Fixed Position Button -->
            <div class="button-wrapper">
                <DefaultButton
                    text={$_("restaurant_current_menu")}
                    isPrimary={false}
                />
            </div>
            <div class="divider-h divider" />
            <OpeningHours openingHours={restaurant.openingHours} />
            <div class="divider-h divider" />
            <!-- Adresse -->
            <ContentSection title={$_("address")}>
                <div slot="content" class="address-content">
                    <div class="text-l">{restaurant.address.name}</div>
                    <div class="text-l">{restaurant.address.street}</div>
                    <div class="text-l">{restaurant.address.city}</div>
                     <!-- Bild Anfahrt -->
                    <img
                            src={restaurant.mapImage}
                            alt={$_("drive_title")}
                            class="map-image"
                    />
                </div>
            </ContentSection>
            <div class="divider-h divider" />
            <!-- Kontakt -->
            <Contact phone={restaurant.phone} email={restaurant.email} />

            <div class="divider-h divider" />
            <!-- Reservationen -->
            <ContentSection title={$_("reservations_title")}>
                <div slot="content" class="content">
                    <span class="text-l">{restaurant.reservationNotice}</span>
                </div>
            </ContentSection>
        </div>
    </GeneralVisitPage>
</main>

<style>
    .divider {
        margin: 16px 0;
    }

    .content {
        margin-bottom: 16px;
    }

    .button-wrapper {
        padding: 32px 0px;
        position: relative;
        z-index: -1;
    }

    .info-wrapper {
        padding: 0 0;
    }

    .map-image {
        max-width: 100%;
        margin-top: 32px;
    }

    @media only screen and (min-width: 1440px) {

        .map-image {
            max-width: 544px;
            max-height: 279px;
        }
    }
</style>
